import React from 'react';
import { Text, VStack, Select } from '@chakra-ui/react';
import { Schedule } from '~/types/common';

import { format, addMinutes, startOfDay } from 'date-fns';

import * as fp from 'lodash/fp';

type PickupDurationSelectProps = {
  durationList: Array<Schedule>;
  pickMealTime: {
    pickMealAtTimeMin: number;
    pickMealEndTimeMin: number;
  } | null;
  onChangePickMealTime: (schedule: Schedule | null) => void;
};

// 時段選擇
export default function PickupDurationSelect({
  durationList,
  pickMealTime,
  onChangePickMealTime,
}: PickupDurationSelectProps) {
  const selectedIndex = durationList.findIndex(
    ({ start }) => pickMealTime?.pickMealAtTimeMin === start,
  );

  const handleFormatTimeMin = (schedule: Schedule) => {
    const date = startOfDay(new Date());

    return `${format(addMinutes(date, schedule.start), 'aa hh:mm')} ~ ${format(
      addMinutes(date, schedule.end),
      'aa hh:mm',
    )}`;
  };

  const handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const schedule = durationList.find((_, index) => fp.eq(index.toString(), e.target.value));

    onChangePickMealTime(schedule || null);
  };

  return (
    <VStack align="stretch">
      <Text fontSize="sm">選擇時段</Text>
      <Select
        cursor="pointer"
        placeholder={'請選擇時間'}
        value={selectedIndex}
        variant="flushed"
        borderBottom="4px solid"
        borderBottomColor={pickMealTime ? 'fontColor' : 'danger.600'}
        onChange={handleSelectChange}
        color={pickMealTime ? 'fontColor' : 'danger.600'}
        _focus={{
          boxShadow: 'unset',
        }}
      >
        {durationList.map((schedule, index) => (
          <option key={schedule.start} value={index}>
            {handleFormatTimeMin(schedule)}
          </option>
        ))}
      </Select>
    </VStack>
  );
}
